import { useState } from 'react';
import axios from 'axios';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsletterSignup() {
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email) return;

        setIsLoading(true);
        try {
            await axios.post(`${API}/newsletter/subscribe`, { email });
            toast.success('Welcome to the fam!', {
                description: "You'll be the first to know about new drops.",
            });
            setEmail('');
        } catch (error) {
            toast.error('Something went wrong', {
                description: 'Please try again later.',
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <section 
            data-testid="newsletter-section"
            className="relative bg-brand-surface py-24 overflow-hidden"
        >
            {/* Background Effect */}
            <div className="absolute inset-0 opacity-30">
                <div 
                    className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px]"
                    style={{
                        background: 'radial-gradient(circle, rgba(148, 163, 184, 0.2) 0%, transparent 70%)',
                        filter: 'blur(60px)'
                    }}
                />
            </div>

            <div className="relative max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
                <div className="max-w-2xl">
                    <h2 className="font-syne font-extrabold text-4xl md:text-5xl text-white tracking-tight mb-4">
                        STAY FADED
                    </h2>
                    <p className="font-space text-slate-400 text-lg mb-8">
                        Get exclusive drops, tour announcements, and behind-the-scenes content.
                    </p>

                    <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4">
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                            data-testid="newsletter-email-input"
                            className="flex-1 bg-black/50 border-b border-white/20 focus:border-white outline-none px-0 py-4 text-white placeholder:text-neutral-600 rounded-none transition-colors font-space"
                        />
                        <Button
                            type="submit"
                            data-testid="newsletter-submit-btn"
                            disabled={isLoading}
                            className="bg-white text-black hover:bg-slate-200 rounded-none px-8 py-4 font-bold uppercase tracking-widest flex items-center gap-2"
                        >
                            {isLoading ? 'JOINING...' : 'JOIN'}
                            <ArrowRight className="w-4 h-4" />
                        </Button>
                    </form>
                </div>
            </div>
        </section>
    );
}
